import 'swiper/css/bundle';
import Swiper from 'swiper';

import './single-press.scss';

const singlePress = () => {

    let args = {
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 10,

            },
            500: {
                slidesPerView: 3,

            },
            1024: {
                slidesPerView: 4,
            }
        },

    };
    let pressSwiper = new Swiper(document.querySelector('.relatedProductsSwiper'), args);
}

export default singlePress;